import './analyticsConsent.css';
import {
  getAnalyticsConsent,
  initAnalyticsWithConsent,
  isAnalyticsEnabled,
  setAnalyticsConsent,
} from './analytics';
import { initLocale, t } from './i18n';

const BANNER_ID = 'analytics-consent-banner';

function removeConsentBanner(): void {
  document.getElementById(BANNER_ID)?.remove();
  document.getElementById('analytics-consent-backdrop')?.remove();
}

function showConsentBanner(): void {
  if (document.getElementById(BANNER_ID)) return;

  const backdrop = document.createElement('div');
  backdrop.id = 'analytics-consent-backdrop';
  backdrop.className = 'analytics-consent-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');

  const root = document.createElement('div');
  root.id = BANNER_ID;
  root.className = 'analytics-consent';
  root.setAttribute('role', 'dialog');
  root.setAttribute('aria-modal', 'true');
  root.setAttribute('aria-labelledby', 'analytics-consent-title');

  root.innerHTML = `
    <div class="analytics-consent-inner">
      <p id="analytics-consent-title" class="analytics-consent-title"></p>
      <p class="analytics-consent-text"></p>
      <div class="analytics-consent-actions">
        <button type="button" class="analytics-consent-btn analytics-consent-decline"></button>
        <button type="button" class="analytics-consent-btn analytics-consent-accept"></button>
      </div>
    </div>
  `;

  const titleEl = root.querySelector('.analytics-consent-title');
  const textEl = root.querySelector('.analytics-consent-text');
  const declineBtn = root.querySelector('.analytics-consent-decline') as HTMLButtonElement;
  const acceptBtn = root.querySelector('.analytics-consent-accept') as HTMLButtonElement;

  if (titleEl) titleEl.textContent = t('consent.title');
  if (textEl) textEl.textContent = t('consent.message');
  if (declineBtn) declineBtn.textContent = t('consent.decline');
  if (acceptBtn) acceptBtn.textContent = t('consent.accept');

  declineBtn?.addEventListener('click', () => {
    setAnalyticsConsent(false);
    removeConsentBanner();
  });
  acceptBtn?.addEventListener('click', () => {
    setAnalyticsConsent(true);
    removeConsentBanner();
  });

  document.body.appendChild(backdrop);
  document.body.appendChild(root);
  acceptBtn?.focus();
}

/** Register analytics page and show consent overlay when needed. */
export function setupAnalyticsConsent(pagePath: string, pageTitle: string): void {
  if (!isAnalyticsEnabled()) return;
  initLocale();
  initAnalyticsWithConsent(pagePath, pageTitle);
  if (getAnalyticsConsent() === null) showConsentBanner();
}
